import React from "react";

import { Typography, Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export const RegisterUserAgreementSubform = () => {
  //Hooks
  const { t } = useTranslation();

  return (
    <Grid
      justify="center"
      className="common-notice-container"
      direction="column"
      spacing={2}
      container
    >
      <Grid item>
        <Typography className="common-notice">
          {t(
            `The information you provide is not sufficient to fully assess the appropriateness of the investment. There is therefore a risk that the investment involves a risk that is not appropriate for you.`
          )}
        </Typography>
      </Grid>
    </Grid>
  );
};
